export var SteemActionType;
(function (SteemActionType) {
    // ACCOUNT ACTIONS
    SteemActionType["GET_ACCOUNTS"] = "GET_ACCOUNTS";
    SteemActionType["ADD_ACCOUNT"] = "ADD_ACCOUNT";
    SteemActionType["SET_ACCOUNTS"] = "SET_ACCOUNTS";
    SteemActionType["RESET_ACCOUNT"] = "RESET_ACCOUNT";
    // ACTIVE ACCOUNT ACTIONS
    SteemActionType["SET_ACTIVE_ACCOUNT"] = "ACTIVE_ACCOUNT";
    SteemActionType["SET_ACTIVE_ACCOUNT_RC"] = "ACTIVE_ACCOUNT_RC";
    SteemActionType["FORGET_ACCOUNT"] = "FORGET_ACCOUNT";
    SteemActionType["FORGET_ACCOUNTS"] = "FORGET_ACCOUNTS";
    SteemActionType["RESET_ACTIVE_ACCOUNT"] = "RESET_ACTIVE_ACCOUNT";
    // ACTIVE RPC ACTIONS
    SteemActionType["SET_ACTIVE_RPC"] = "SET_ACTIVE_RPC";
    SteemActionType["ADD_CUSTOM_RPC"] = "ADD_CUSTOM_RPC";
    //PRICES
    SteemActionType["LOAD_CURRENCY_PRICES"] = "LOAD_CURRENCY_PRICES";
    //GLOBAL PROPERTIES
    SteemActionType["LOAD_GLOBAL_PROPS"] = "LOAD_GLOBAL_PROPS";
    // CONVERSION
    SteemActionType["FETCH_CONVERSION_REQUESTS"] = "FETCH_CONVERSION_REQUESTS";
    // DELEGATION
    SteemActionType["FETCH_DELEGATEES"] = "FETCH_DELEGATEES";
    SteemActionType["FETCH_DELEGATORS"] = "FETCH_DELEGATORS";
    SteemActionType["FETCH_PENDING_OUTGOING_UNDELEGATION"] = "FETCH_PENDING_OUTGOING_UNDELEGATION";
    // TOKEN HISTORY
    SteemActionType["LOAD_TOKEN_HISTORY"] = "LOAD_TOKEN_HISTORY";
    SteemActionType["FETCH_MORE_TOKEN_HISTORY"] = "FETCH_MORE_TOKEN_HISTORY";
    SteemActionType["INIT_TOKEN_HISTORY"] = "INIT_TOKEN_HISTORY";
    SteemActionType["LOAD_TOKENS_MARKET"] = "LOAD_TOKENS_MARKET";
    SteemActionType["LOAD_TOKENS"] = "LOAD_TOKENS";
    SteemActionType["CLEAR_USER_TOKENS"] = "CLEAR_USER_TOKENS";
    SteemActionType["LOAD_USER_TOKENS"] = "LOAD_USER_TOKENS";
    SteemActionType["LOAD_PENDING_UNSTAKING"] = "LOAD_PENDING_UNSTAKING";
    // PHISHING
    SteemActionType["FETCH_PHISHING_ACCOUNTS"] = "FETCH_PHISHING_ACCOUNTS";
    // TRANSACTION
    SteemActionType["ADD_TRANSACTIONS"] = "ADD_TRANSACTIONS";
    SteemActionType["INIT_TRANSACTIONS"] = "INIT_TRANSACTIONS";
    // STEEM ENGINE CONFIG
    SteemActionType["HE_SET_ACTIVE_RPC"] = "HE_SET_ACTIVE_RPC";
    SteemActionType["HE_SET_ACTIVE_ACCOUNT_HISTORY_API"] = "HE_SET_ACTIVE_ACCOUNT_HISTORY_API";
    SteemActionType["HE_LOAD_CONFIG"] = "HE_LOAD_CONFIG";
    // APP STATUS
    SteemActionType["SET_APP_STATUS"] = "SET_APP_STATUS";
    // RPC SWITCH
    SteemActionType["SET_SWITCH_TO_RPC"] = "SET_SWITCH_TO_RPC";
    SteemActionType["SET_DISPLAY_SWITCH_RPC"] = "SET_DISPLAY_SWITCH_RPC";
    SteemActionType["IS_LOADING"] = "IS_LOADING";
})(SteemActionType || (SteemActionType = {}));
